import { render, staticRenderFns } from "./JitsiVideoCall.vue?vue&type=template&id=14fbe55e&scoped=true&"
import script from "./JitsiVideoCall.vue?vue&type=script&lang=js&"
export * from "./JitsiVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./JitsiVideoCall.vue?vue&type=style&index=0&id=14fbe55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fbe55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
